<template>
  <div>
    <modules
      :moduleType="moduleType"
      @currentModuleIdChanged="currentModuleIdChanged"
      :hasAdd="authority.IsAdd"
      :hasEdit="authority.IsUpdate"
      :hasRemove="authority.IsRemove"
    >
      <template slot="buttons">
        <button
          type="button"
          class="btn btn-outline-primary btn-icon"
          v-if="authority.IsUpdate"
          @click="dayClick"
        >
          <i class="fas fa-calendar-alt"></i>
        </button>
      </template>
    </modules>

    <router-view />
  </div>
</template>

<script>
import modules from "@/components/modules/Modules";

export default {
  data() {
    return {
      moduleType: 1,
      currentModuleId: "",
      authority: {},
    };
  },
  components: {
    modules,
  },
  methods: {
    isSelected() {
      if (this.currentModuleId && this.currentModuleId.length > 0) {
        return true;
      } else {
        this.$func.message.alert("請選擇一筆模組 !");
        return false;
      }
    },
    currentModuleIdChanged(id) {
      this.currentModuleId = id;
    },
    dayClick() {
      if (!this.isSelected()) {
        return;
      }
      this.$router.push({ name: "Day", params: { id: this.currentModuleId } });
    },
  },
  created() {
    this.authority = this.$func.localStorage.getAuthByName(this.$route.name);
  },
};
</script>
